import { Money } from "models/Invoice/Money";
import { Field } from "sparkson";
import { Marker } from "./Marker";

@Marker
export class Benefit {
  constructor(
    @Field("charge") public price: Money,
    @Field("family") public family: string,
    @Field("active") public isActive: boolean,
    @Field("id") public id: string,
    @Field("package", true) public packageName?: string,
    @Field("baseBenefit", true) public baseBenefit?: boolean
  ) {}
}


export type BenefitPayload = Omit<Benefit, "id" & "charge"> & {"price": Money}